import { Button } from "@/components/ui/button";
import { Edit } from "lucide-react";

interface EditButtonProps {
  onClick: () => void;
}

export const EditButton = ({ onClick }: EditButtonProps) => (
  <Button variant="ghost" size="icon" onClick={onClick}>
    <Edit className="h-4 w-4" />
  </Button>
);